import React, { Component } from 'react';
import resume from '../assets/resume.pdf'

class About extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var profilepic= "images/"+this.props.data.image;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
    }

    return (
      <section id="about">
      <div className="row">
         <div className="three columns">
            <img className="profile-pic"  src={profilepic} alt="Mario Sanz Profile Pic" />
         </div>
         <div className="nine columns main-col">
            <h2>About Me</h2>

            <p>I am a passionate Computer Scientist with a focus on AI and Data Science. Throughout my studies in Computer Science Engineering, I realized my deep interest in the field of Artificial Intelligence and Data Science. My love for data, programming, and problem solving has solidified my determination to pursue a career in this domain.<br /><br />

            I am enthusiastic about exploring the vast possibilities of AI and data science, and I am passionate about ideating, conceptualizing, and developing consumer-centric and technology-enabled products from scratch. I am eager to explore diverse project opportunities in both startup environments and established companies, where I can apply my expertise in AI and Data Science to make a meaningful impact.</p>
            <div className="row">
               <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                     <span>{name}</span>
                     <span>{street}<br />
                        {city}, {state}
                     </span><br />
                     <span>{phone}</span><br />
                     <span><a href={`mailto:${email}?subject=The%20subject%20of%20the%20mail`}>{email}</a></span>
                  </p>
               </div>
               <div className="columns download">
                  <p>
                    <a href={resume} target="_blank" rel="noopener noreferrer" className="button"><i className="fa fa-download"></i>Download Resume</a>
                  </p>
               </div>
            </div>
         </div>
      </div>
   </section>
    );
  }
}

// MODIFICABLE: {city}, {state}, {zip}

export default About;
